export default class SearchModel {
  /**
   * Search Model for Locations Filter
   * @param {string} locationName
   * @param {int} countryId
   * @param {int} countrySubdivisionId
   * @param {string} locationStreetAddress1
   * @param {string} locationPostalCode
   * @param {int} siteId
   * @param {string} sourceSystemReferenceId
   * @param {string} LocationCity
   */

  //Initializing this class empty strings prevents UDM_UI from sending UDM_API an empty object
  constructor() {
    this.locationName = '';
    this.countryId = '';
    this.countrySubdivisionId = '';
    this.locationStreetAddress1 = '';
    this.locationPostalCode = '';
    this.siteId = '';
    this.sourceSystemReferenceId = '';
    this.locationCity = '';
  }
}
